// What Profit On Your Terms's home reads and writes beyond the product's own rows (src/product/data.js):
// the deal surgery (docs/data-model.md 10.6.2). As the member themselves, through row level security.
//
// - Whether they've asked: their own row in hub.deal_surgery_requests for the product (1 per person
//   and product). It's filtered to them too, because an owner or admin reads everyone's.
// - Asking: an insert of (person_id, product_id) only; the database stamps the time and picks their
//   own open intake with the deal surgery on, or refuses (42501 no_deal_surgery). Asked already is
//   23505 (deal_surgery_requests_once). It puts a job on Adam's Today and sends no email.
// While staff view as a member nothing here writes (the screen's button is off, and the database
// refuses the insert anyway).
import { supabase, must } from '../../lib/supabase.js'

export const SURGERY_COLUMNS = 'id, requested_at'

export async function loadSurgeryRequest(personId, productId) {
  const rows = await supabase.from('deal_surgery_requests').select(SURGERY_COLUMNS)
    .eq('person_id', personId).eq('product_id', productId).order('requested_at').then(must)
  return rows?.[0] || null
}

export async function askForSurgery(personId, productId) {
  const rows = await supabase.from('deal_surgery_requests').insert({ person_id: personId, product_id: productId })
    .select(SURGERY_COLUMNS).then(must)
  return rows?.[0] || null
}
